import chunk from 'lodash.chunk';
import { displayShortDate } from '../../utils/Format/Format';
import { isExpectingMonthlyData } from '../../utils/time';

const sortTopTenCountries = (data) => {
    if (!(data && data.length)) return [];

    return [...data]
        .sort((a, b) => b.percentTotalNetAssets - a.percentTotalNetAssets)
        .slice(0, 10);
};

const checkForValues = (data) =>
    data.some((dt) => Boolean(dt.percentTotalNetAssets));

export const geographicalExposureChartCardUtil = (gqlResult) => {
    if (!gqlResult) return null;

    const { inceptionDate, countryRankings } = gqlResult.mutualFund;

    const asOfDate =
        (countryRankings &&
            countryRankings[0] &&
            countryRankings[0].asOfDate &&
            displayShortDate(countryRankings[0].asOfDate)) ||
        'N/A';

    const data = sortTopTenCountries(countryRankings);

    const hasValues = checkForValues(data);

    // chunk data to display in columns, 5 rows each
    const chunkedData = chunk(data, 5).map((d) => ({ data: d }));

    return {
        data: chunkedData,
        hasValues,
        asOfDate,
        isGeoCardNew: !isExpectingMonthlyData(inceptionDate)
    };
};

export const geographicalExposureChartCardUtilETF = (gqlResult) => {
    if (!gqlResult) return null;

    const {
        inceptionDate,
        countryAllocation: {
            asOfDate: date,
            oneMonthAllocation: { fundAllocationData = [] } = {}
        } = {}
    } = gqlResult.exchangeTradedFund;

    const asOfDate = date ? displayShortDate(date) : 'N/A';

    const data = sortTopTenCountries(fundAllocationData);

    const hasValues = checkForValues(data);

    // chunk data to display in columns, 5 rows each
    const chunkedData = chunk(data, 5).map((d) => ({ data: d }));

    return {
        data: chunkedData,
        hasValues,
        asOfDate,
        isGeoCardNew: !isExpectingMonthlyData(inceptionDate)
    };
};
